export default __webpack_public_path__ + "static/media/address_book_empty_state.285d2a34.svg";